import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Checkbox, FormField, LineInputRange } from "ui";

import { NotificationFormValues } from "../NotificationForm.types";

import styles from "../NotificationForm.module.scss";

export const AgeField = () => {
  const { t } = useTranslation();
  const { control, watch } = useFormContext<NotificationFormValues>();

  const notRelevantAgeWatch = watch("notRelevantAge");

  return (
    <div>
      <Controller
        control={control}
        name={"age"}
        render={({
          field: { value, onChange },
          fieldState: { error: _error }
        }) => (
          <FormField label={t("Age")} labelClassName={styles.form_fieldLabel}>
            <LineInputRange
              values={value}
              min={1}
              max={100}
              onChange={onChange}
              withInputs
              disabled={notRelevantAgeWatch}
            />
          </FormField>
        )}
      />

      <Controller
        control={control}
        name="notRelevantAge"
        render={({ field: { value, onChange } }) => (
          <Checkbox
            checked={value}
            label={t("Not Relevant")}
            onChange={onChange}
            className={styles.form_checkbox}
          />
        )}
      />
    </div>
  );
};
